// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2s1d1","clinicsSelect":"TableHeading_clinicsSelect__1VDsJ"};